import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
import { motion } from 'framer-motion';

const NotFoundPage = () => (
  <>
    <SEO title="Page Not Found | Nebraska Backyard Living" description="Looks like this backyard path took a wrong turn." path="/404" noindex />
    <section className="noise-dark flex min-h-screen items-center bg-graphite text-paper">
      <div className="container-site relative z-10 py-32">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}>
          <p className="overline-label">404</p>
          <h1 data-testid="not-found-heading" className="mt-4 max-w-2xl font-serif text-5xl font-medium leading-[1.02] tracking-tight sm:text-6xl">
            Looks like this backyard path took a wrong turn.
          </h1>
          <p className="mt-6 max-w-md text-lg text-paper/70">
            The page you're looking for isn't here — but your dream backyard still is.
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <Link to="/" data-testid="not-found-home" className="btn-primary">Back to Home</Link>
            <Link to="/services/" data-testid="not-found-services" className="btn-outline-light">Explore Services</Link>
            <Link to="/get-a-quote/" data-testid="not-found-quote" className="btn-outline-light">Get a Free Quote</Link>
          </div>
        </motion.div>
      </div>
    </section>
  </>
);

export default NotFoundPage;
